import { Module } from 'vuex'
import { ExamState } from './types'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { RootState } from '../types';

const state: ExamState = {
  exam: {endpoints: {}},
  currentQuestionIndex: -1,
  questions: [],
  answers: [],
  loaded: false,
  confirmSubmit: false,
  timer: -1,
  counter: -1
}

export const store: Module<ExamState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
